export const RETAIL_ENERGY_ORDERS_ENDPOINT = '/retail-energy-orders';
export const LIGHTING_RETROFIT_ORDERS_ENDPOINT = '/lighting-retrofit-orders';
